import { createMuiTheme } from '@zn-material-ui'

export default createMuiTheme({
  props: {
    MuiList: {
      style: {
        padding: '0px',
      },
    },
    MuiListItem: {
      alignItems: 'flex-start',
      style: {
        paddingLeft: '20px',
        paddingTop: '20px',
        paddingBottom: '20px',
        cursor: 'pointer',
      },
    },
    MuiCard: {
      elevation: 0,
    },
    MuiCardActions: {
      disableSpacing: true,
    },
  },
  palette: {
    primary: {
      main: '#2A6EED',
    },
    secondary: {
      main: '#fff',
    },
    text: {
      primary: '#333',
      secondary: '#999',
      // disabled: string;
      hint: '#1F1F1F',
    },
    action: {
      hover: '#2A6EED',
      selected: '#2A6EED',
      active: '#2A6EED',
      disabled: 'rgba(42,110, 237, 0.5)',
    },
  },
  typography: {
    fontFamily: [
      'Arial',
      'Hiragino Sans GB',
      'PingFang SC',
      'Microsoft YaHei',
      'Helvetica',
      'Helvetica Neue',
      'Tahoma',
      'sans-serif',
    ].join(','),
    allVariants: {
      color: '#333333',
    },
  },
  zIndex: {
    appBar: 999,
  },
  one_login_width: 57,
  content_box_width: 1200,
  live_gradient_color: 'linear-gradient(-270deg, #2A6EED 0%, #3C94FF 100%)',
})
